module.exports = __webpack_public_path__ + "img/KinokoTable31.544e0258.jpg";